import { usePublicOrderWithItems } from "@babackapp/private-api-client/client/use-search-public-order";
import { useParams } from "react-router-dom";
import { useCurrentOrderReturnRequests } from "./return-request";

export function useCurrentOrderLineItems() {
  const { orderId } = useParams();
  return usePublicOrderWithItems(orderId!, {
    select: (data) => data?.lineItems ?? [],
  });
}

export function useCurrentOrderReturnableLineItems() {
  const { orderId } = useParams();
  const { data: orderLineItems } = useCurrentOrderLineItems();
  const { data: returnRequests } = useCurrentOrderReturnRequests();

  const returnedLineItems = returnRequests.returnRequests.flatMap(
    (rr) => rr.line_items.filter((li) => li.quantity > 0) ?? [],
  );

  const returnableLineItems = orderLineItems.filter((oli) => {
    const returnedQuantity =
      returnedLineItems.find((rli) => rli.line_item_id === oli.line_item_id)
        ?.quantity ?? 0;

    return oli.quantity_bought > returnedQuantity;
  });

  return returnableLineItems;
}
